var enerclub = (function ($) {

    var _addLimitLinesProp = function () {
        $(".limit_lines").css("-webkit-box-orient", "vertical");
    }

    var _cardImgEffects = function () {
        //Animaciones al hacer scroll
        $(window).on("scroll", function (params) {
            var blockEffects = $(".enerclub_effect_img_wrapper");
            if (!blockEffects.length) return;
            var topOfWindow = $(window).scrollTop();

            var offset = 300;

            $(blockEffects).each(function () {
                var blockEffect = $(this).offset().top;
                offset = $(this).data("offset");
                if (topOfWindow >= blockEffect - offset) {
                    $(this).find(".card-img-top").addClass("_loaded");
                }
            });
        });
    };

    var initForm = function (elParent = document) {
        $(elParent).find("[data-enerclub-datepicker]").datepicker({
            closeText: 'Cerrar',
            prevText: '< Ant',
            nextText: 'Sig >',
            currentText: 'Hoy',
            monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
            dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Juv', 'Vie', 'Sáb'],
            dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
            firstDay: 1, //Hace que la semana comience en Lunes
            changeMonth: true,
            changeYear: true,
            yearRange: "-100:+0",
            dateFormat: "dd/mm/yy",
        });



        // - select2
        // - fix select2 con el admin bar de wp
        if ($('body.logged-in.admin-bar').length > 0) {
            $('html').attr('style', 'margin-top: 0 !important;');
        }

        $(elParent).find("[data-enerclub-combo]").each((index, el) => {
            let opt = {
                theme: "bootstrap-5",
                language: "es"
            };
            if ($(el).attr('placeholder')) {
                opt.placeholder = $(el).attr('placeholder');
            }
            if ($(el).attr('data-enerclub-combo-minimumResultsForSearch')) {
                opt.minimumResultsForSearch = $(el).attr('data-enerclub-combo-minimumResultsForSearch');
            }
            if ($(el).attr('data-enerclub-combo-allowClear')) {
                opt.allowClear = $(el).attr('data-enerclub-combo-allowClear');
            }

            var select2 = $(el).select2(
                opt
            );
            // fix para que funcione jquery validator
            select2.on("select2:close", function (e) {
                $(el).trigger('blur');
            });

            // steal focus during close - only capture once and stop propogation
            select2.on('select2:closing', function (e) {
                $(e.target).data("select2").$selection.one('focus focusin', function (e) {
                    e.stopPropagation();
                });
            });
        });

        // hack to fix jquery 3.6 focus security patch that bugs auto search in select-2
        $(document).off('select2:open');
        $(document).on('select2:open', () => {
            document.querySelector('.select2-search__field').focus();
        });


        // on first focus (bubbles up to document), open the menu
        $(document).off('focus.select2-selection--single', '.select2-selection.select2-selection--single');
        $(document).on('focus.select2-selection--single', '.select2-selection.select2-selection--single', function (e) {
            $(this).closest(".select2-container").siblings('select:enabled').select2('open');
        });
    }

    var _showContactForm = function () {
        $("#btn_contact").on("click", function () {
            if ($(".contact_panel").hasClass('active') && $(".contact_panel_overlay").hasClass('active')) {
                $(".contact_panel").removeClass('active');
                $(".contact_panel_overlay").removeClass('active');
            } else {
                $(".contact_panel").addClass('active');
                $(".contact_panel_overlay").addClass('active');
            }
        });
        $(".contact_panel_overlay").on("click", function () {
            if ($(".contact_panel").hasClass('active') && $(".contact_panel_overlay").hasClass('active')) {
                $(".contact_panel").removeClass('active');
                $(".contact_panel_overlay").removeClass('active');
            }
        });
        $(".btn_close_contact").on("click", function () {
            if ($(".contact_panel").hasClass('active') && $(".contact_panel_overlay").hasClass('active')) {
                $(".contact_panel").removeClass('active');
                $(".contact_panel_overlay").removeClass('active');
            }
        });
    }

    var _toggleMenuThirdLevel = function () {
        // dropdown multilevel
        $(".dropdown-menu > li > .dropdown-menu")
            .parent()
            .addClass("dropdown-submenu")
            .find(" > .dropdown-item")
            .attr("href", "javascript:;")
            .addClass("dropdown-toggle");
        $(".dropdown-submenu > a").on("click", function (e) {
            var dropdown = $(this).parent().find(" > .show");
            $(".dropdown-submenu .dropdown-menu").not(dropdown).removeClass("show");
            $(this).parent().toggleClass("show");
            $(this).next(".dropdown-menu").toggleClass("show");
            e.stopPropagation();
        });

        // hide all open menus if the parent closes
        $(".dropdown").on("hidden.bs.dropdown", function () {
            $(".dropdown-menu.show").removeClass("show");
        });
    };

    var _createCookies = function () {
        var settings = $("#cookie_preferences").cookiePreferences("settings");
        if (settings && settings.analysis) {
            // Evento y variable de Google Tag Manager
            dataLayer.push({
                cookie_consent: "true",
                event: "consent_given",
            });
        }

        if (settings && settings.advertising) {
            // Evento y variable de Google Tag Manager
            dataLayer.push({
                cookie_ads: "true",
                event: "consent_ads",
            });
        }
    };

    var _updateCookieSelection = function () {
        $("#CookiePreferenceDialogBodyLevelButtonFuncionality").on(
            "click",
            function () {
                if (
                    $("#CookiePreferenceDialogBodyLevelButtonFuncionality").is(":checked")
                ) {
                    $("#CookiePreferenceDialogBodyLevelButtonFuncionalityInline").prop(
                        "checked",
                        true
                    );
                } else {
                    $("#CookiePreferenceDialogBodyLevelButtonFuncionalityInline").prop(
                        "checked",
                        false
                    );
                }
            }
        );

        $("#CookiePreferenceDialogBodyLevelButtonFuncionalityInline").on(
            "click",
            function () {
                if (
                    $("#CookiePreferenceDialogBodyLevelButtonFuncionalityInline").is(
                        ":checked"
                    )
                ) {
                    $("#CookiePreferenceDialogBodyLevelButtonFuncionality").prop(
                        "checked",
                        true
                    );
                } else {
                    $("#CookiePreferenceDialogBodyLevelButtonFuncionality").prop(
                        "checked",
                        false
                    );
                }
            }
        );

        $("#CookiePreferenceDialogBodyLevelButtonPerformance").on(
            "click",
            function () {
                if (
                    $("#CookiePreferenceDialogBodyLevelButtonPerformance").is(":checked")
                ) {
                    $("#CookiePreferenceDialogBodyLevelButtonPerformanceInline").prop(
                        "checked",
                        true
                    );
                } else {
                    $("#CookiePreferenceDialogBodyLevelButtonPerformanceInline").prop(
                        "checked",
                        false
                    );
                }
            }
        );

        $("#CookiePreferenceDialogBodyLevelButtonPerformanceInline").on(
            "click",
            function () {
                if (
                    $("#CookiePreferenceDialogBodyLevelButtonPerformanceInline").is(
                        ":checked"
                    )
                ) {
                    $("#CookiePreferenceDialogBodyLevelButtonPerformance").prop(
                        "checked",
                        true
                    );
                } else {
                    $("#CookiePreferenceDialogBodyLevelButtonPerformance").prop(
                        "checked",
                        false
                    );
                }
            }
        );

        $("#CookiePreferenceDialogBodyLevelButtonAdvertising").on(
            "click",
            function () {
                if (
                    $("#CookiePreferenceDialogBodyLevelButtonAdvertising").is(":checked")
                ) {
                    $("#CookiePreferenceDialogBodyLevelButtonAdvertisingInline").prop(
                        "checked",
                        true
                    );
                } else {
                    $("#CookiePreferenceDialogBodyLevelButtonAdvertisingInline").prop(
                        "checked",
                        false
                    );
                }
            }
        );

        $("#CookiePreferenceDialogBodyLevelButtonAdvertisingInline").on(
            "click",
            function () {
                if (
                    $("#CookiePreferenceDialogBodyLevelButtonAdvertisingInline").is(
                        ":checked"
                    )
                ) {
                    $("#CookiePreferenceDialogBodyLevelButtonAdvertising").prop(
                        "checked",
                        true
                    );
                } else {
                    $("#CookiePreferenceDialogBodyLevelButtonAdvertising").prop(
                        "checked",
                        false
                    );
                }
            }
        );
    };

    var _closeCookiesModal = function () {
        if ($("#cookie_preferences").hasClass("show")) {
            $("#cookie_preferences").removeClass("show");
        }
    };
    var _showCookiesModal = function () {
        if (!$("#cookie_preferences").hasClass("show")) {
            $("#cookie_preferences").addClass("show");
        }
    };

    var _startShowingCookiesModal = function () {
        var existsCookiePreferences = false;
        if (document.cookie && document.cookie != "") {
            var cookie = document.cookie.split(";");
            for (var i = 0; i < cookie.length; i++) {
                var cookieName = cookie[i].split("=");
                for (var a = 0; a < cookieName.length; a++) {
                    if (cookieName[a] === 'cookies.preferences' || cookieName[a] === ' cookies.preferences') {
                        existsCookiePreferences = true;
                    }
                }
            }
        }
        if (existsCookiePreferences) {
            _closeCookiesModal();
        } else {
            _showCookiesModal();
        }
    }

    return {
        addLimitLinesProp: _addLimitLinesProp,
        cardImgEffects: _cardImgEffects,
        initForm,
        showContactForm: _showContactForm,
        toggleMenuThirdLevel: _toggleMenuThirdLevel,
        createCookies: _createCookies,
        updateCookieSelection: _updateCookieSelection,
        closeCookiesModal: _closeCookiesModal,
        showCookiesModal: _showCookiesModal,
        startShowingCookiesModal: _startShowingCookiesModal,
    }

})(jQuery);

export default enerclub;